
import { useStore } from '@/store'
import { computed, defineComponent, inject, onUnmounted, ref, watch } from 'vue'
import RenderingPathService from '@/services/rendering/rendering-path.service'
import * as RenderingConstants from '@/constants/rendering-constants'
import bodySettings from '@/settings/body-settings.json'
import backSettings from '@/settings/back-settings.json'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'RenderingRandselBack',
  props: {
    cameraPos: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const store = useStore()
    const emitter: any = inject('emitter')
    const configBodyId = computed(() => store.getters.configBodyId)
    const configBackId = computed(() => store.getters.configBackId)
    let imagePath = ref('')
    let renderPathService = new RenderingPathService()

    emitter.on('updateConfig', updateRendering)

    // prettier-ignore
    watch(() => configBodyId.value, (_) => { updateRendering() })
    // prettier-ignore
    watch(() => configBackId.value, (_) => { updateRendering() })

    function updateRendering() {
      try {
        const bodyId = renderPathService.formatConfig(configBodyId.value, bodySettings.fullorderColors)
        const backId = renderPathService.formatConfig(configBackId.value, backSettings.backColors)
        setRendering(bodyId, backId)
      } catch (err) {
        SentrySingleton.instance.captureException(err)
      }
    }

    function setRendering(bodyId: string | null, backId: string | null) {
      if (!bodyId || !backId) {
        if (!bodyId) {
          console.error('cannot find body id for RenderingRandselBack')
        }
        imagePath.value = ''
        return
      }
      const camPath = 'cam' + (props.cameraPos + 1) + '/'
      const optionPath = 'back/' + bodyId + '/' + backId + '.png'
      const path = RenderingConstants.path + camPath + optionPath
      imagePath.value = path
    }

    onUnmounted(() => {
      emitter.off('updateConfig', updateRendering)
    })

    return {
      imagePath
    }
  }
})
